/**
 * Resolve a cube-key date range (e.g. `last-7-days`, `custom:groupId`) into
 * a human label for the hover card. Delegates to the shared
 * STATS_DATE_RANGE_PRESETS catalog so the same code maps to the same label
 * everywhere in the app.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { getStatsDateRangeLabel } from '@/components/date-range/dateRangePresets';

const CUSTOM_PREFIX = 'custom:';

export function resolveDateRangeLabel(cubeKey: string): string {
  if (cubeKey.startsWith(CUSTOM_PREFIX)) return 'Custom range';
  return getStatsDateRangeLabel(cubeKey);
}
